/** This is a magic agent ID that indicates the user came through the "organic" pathway. */
export const DEFAULT_AGENT_ID = "2010000";
